import { AxiosHttpClientAdapter } from "./adapters/axios";

export const api = new AxiosHttpClientAdapter();
